
<div class="camps">
    <div class="head">Residency Selection </div>
    <div class="row-icon">
<div class="icons" *ngFor="let opt of options; let domIndex=index;">                  
      <div
      ngxTippy
      [ngxTippy]="defaultTemplate1"
      [tippyProps]="tippyPropsLeft" 
      [tippyName]="'Residency' + opt.label+''+domIndex+''+index"> 
     <img [(ngModel)]="selectValue"  ngDefaultControl  [ngClass]="setClass(opt.value,selectValue)==true? 'sel-org': ''"
     (click)="select(opt.value,opt.value, $event)" 
           [src]="opt.src" >
      <div class="t-template toolTip" #defaultTemplate1>
        <p class="t-template__info" *ngIf="opt?.label">{{opt.label}}</p>
      </div>
    </div>

  </div>
</div>
</div>


